import { useQuery } from "@tanstack/react-query";
import { AXIOS_RESERVATION } from "../utils/axios-interceptors";
import { IUseGetOffersQueryResponse } from "../utils/types";
import { MyStayType } from "../utils/types/offers";

const useGetMyStayRecommendations = (data?: { page: number; perPage: number }): IUseGetOffersQueryResponse => {
  return useQuery({
    queryKey: ["my-stay-recommendations", data?.page, data?.perPage],
    queryFn: async () => {
      const response = await AXIOS_RESERVATION.get(`v1/coupons?myStayType=${MyStayType.RECOMMENDATION}`, {
        params:  data,
      });
      return response.data;
    },
  });
};

export default useGetMyStayRecommendations;
